export default "__VITE_ASSET__xnDgY_n4__";